export function insertParams(url, params) {
  if (!params) {
    return url;
  }
  let outputUrl = url;
  if (url.indexOf('?') === -1) {
    outputUrl += '?';
  } else {
    outputUrl += '&';
  }
  const keys = Object.keys(params);
  let index = 0;
  return keys.reduce(function(currentUrl, key) {
    const value = params[key];
    if (value) {
      return currentUrl + (index++ > 0 ? '&' : '') + encodeURI(key) + '=' + encodeURI(value);
    }
    return currentUrl;
  }, outputUrl);
}



// WEBPACK FOOTER //
// ./src/core/actionHelpers.js